import { isNull, get } from "lodash"
import img_18 from "./img/img_18-29.png"
import img_30 from "./img/img_30-39.png"
import img_40 from "./img/img_40-49.png"
import img_50 from "./img/img_50-59+.png"

import img_18_male from "./img/male-18.png"
import img_30_male from "./img/male-30.png"
import img_40_male from "./img/male-40.png"
import img_50_male from "./img/male-50.png"

export const checkIsValidSex = data => {
    return validateSexStep(get(data, ["old", "value"], "")) && !data.old.isValid
}

export const validateSexStep = value => {
    return !isNull(value)
}

export const oldData = {
    '25': {
        value: 25,
        title: "18-29",
        imgFemale: img_18,
        imgMale: img_18_male,
    },
    '34': {
        value: 34,
        title: "30-39",
        imgFemale: img_30,
        imgMale: img_30_male,
    },
    '45': {
        value: 45,
        title: "40-49",
        imgFemale: img_40,
        imgMale: img_40_male,
    },
    '55': {
        value: 55,
        title: "50-59+",
        imgFemale: img_50,
        imgMale: img_50_male,
    },
}